import type { FaireProductEntity } from "../../entity_types/product";

export const p_tqhjaddw2v: FaireProductEntity = {
  token: "p_tqhjaddw2v",
  type: "product",
  name: "Island Escape Gift Set",
  brandName: "Beachy Bubbles Bath Co",
  imageUrl:
    "https://cdn.faire.com/fastly/4224d92f1aa2515003f4567ff6086d35757ebf6cca12939943f60ecae3c526fd.jpeg",
  priceDollars: 15,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/a949fd083e0ea5e11816db0f01145e762cc7fa2fa71b32c8b4373db19e2d74c8.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
